import { useAppDescriptions } from '../product-descriptions';

import { EDITIONS } from './common/edition-options';
import { ProductCard } from './common/product-card';
import { useProductCardData } from './common/use-product-card-data';

export const ConfluenceProductCard = () => {
	const { iconUrl, description } = useAppDescriptions().confluence;
	return (
		<ProductCard
			{...useProductCardData('confluence')}
			title="Confluence"
			iconUrl={iconUrl}
			description={description}
			unitLabelPlural="users"
			unitLabelSingular="user"
			editions={EDITIONS}
		/>
	);
};
